import { render, staticRenderFns } from "./PanelColorSelector.vue?vue&type=template&id=32795428&scoped=true"
import script from "./PanelColorSelector.vue?vue&type=script&lang=js"
export * from "./PanelColorSelector.vue?vue&type=script&lang=js"
import style0 from "./PanelColorSelector.vue?vue&type=style&index=0&id=32795428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32795428",
  null
  
)

export default component.exports